import React, { useEffect, useState } from "react";
import { addDoc, collection } from "firebase/firestore";
import { auth, db } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import { getDocs } from "firebase/firestore";
import "./../styles/form.css";
import Blog from "../components/Blog";

function CreateProject({ isAuth }) {
  let navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [tags, setTags] = useState([{ tag: "" }]);
  const [projectDetails, setProjectDetails] = useState("");
  const createProjectCollectionRef = collection(db, "createProject");

  //Create new project : Send data to firebase.
  const createNewProject = async (e) => {
    e.preventDefault();
    await addDoc(createProjectCollectionRef, {
      title,
      tags: { tag: tags },
      projectDetails: { intro: { title: "", content: "" } },
      //   author: { name: auth.currentUser.displayName, id: auth.currentUser.uid },
    });
    // navigate('/')
  };

  //Get tags value
  const handleTag = (event, index) => {
    let data = [...tags];
    data[index][event.target.name] = event.target.value;
    setTags(data);
  };

  //Add tags
  const addTag = (e) => {
    e.preventDefault();
    let object = {
      tag: "",
    };
    setTags([...tags, object]);
    console.log("Add", object)
  };

  //Remove tags
  const removeTag = (index) => {
    let data = [...tags];
    data.splice(index, 1);
    setTags(data);
    console.log("remove", data)
  };

  //console.log(createNewProject());
  const [projectList, setProjectList] = useState([]);
  const checkLogin = localStorage.getItem("isLogin");
  useEffect(() => {
    const getProject = async () => {
      const data = await getDocs(createProjectCollectionRef);
      setProjectList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getProject();
    if (!checkLogin) {
      //!isAuth
      navigate("/");
    }
  }, []);
  return (
    <div className="formUI">
    <Blog />
      <h2>Create New Project</h2>
      <form className="createForm" onSubmit={createNewProject}>
        <div className="fields">
          <label htmlFor="">Project Title</label>
          <input
            type="text"
            placeholder="Project title"
            onChange={(event) => {
              setTitle(event.target.value);
            }}
          />
        </div>
        <div className="fields">
          <label htmlFor="">Details</label>
          <input
            type="text"
            placeholder="Detail"
            onChange={(event) => {
              setProjectDetails(event.target.value);
            }}
          />
        </div>
        <div className="fields">
          <label htmlFor="">Tags</label>
          <div className="tags">
            {tags.map((tagValue, index) => {
              return (
                <div className="tag" key={index}>
                  <input
                    name="tag"
                    placeholder="Tag"
                    value={tagValue.tag}
                    onChange={(event) => handleTag(event, index)}
                  />
                  <button
                    className="removeBtn"
                    onClick={() => removeTag(index)}
                  >
                    X
                  </button>
                </div>
              );
            })}
            <button className="addnew" onClick={addTag}>
              +
            </button>
          </div>
        </div>
        <div className="fields">
          <button className="createBtn" type="submit">
            Create
          </button>
        </div>
      </form>
      <div className="createForm">
        {projectList.length === 0 ? (
          <p>No Project Found...</p>
        ) : (
          projectList.map((project, i) => <div key={i}>{project.title}</div>)
        )}
      </div>
    </div>
  );
}

export default CreateProject;
